module.exports = __webpack_public_path__ + "static/media/icon-help.a7e4eb2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Nav/assets/icon-help.svg
// module id = 1496
// module chunks = 193